import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import App from './App';
import store, { persistor } from './store/store';
import reportWebVitals from './reportWebVitals';
import { primeClientReportedIpv4 } from './utils/clientIpv4';
import 'react-toastify/dist/ReactToastify.css';

// Warm the ipify cache so audit-log actions (login, signup, client-op) don't
// wait on a cold ipify round-trip at submit time.
primeClientReportedIpv4();

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor: string) => augmentColor({ color: { main: mainColor } });

const theme = createTheme({
  palette: {
    primary: {
      main: '#13236E',
    },
    // @ts-ignore
    darkModePrimary: createColor('#59ceff'),
  },
  typography: {
    fontFamily: ['Raleway', 'Arial'].join(','),
  },
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <CssBaseline />
            <App />
            <ToastContainer position='bottom-right' />
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root') as HTMLElement
);

reportWebVitals();
